<template>
  <div id="side-content">
    <div class="content">{{ $t("message") }}</div>
    <div class="app-version">v1.25.10</div>
  </div>
</template>

<script>
export default {
  name: "DefaultAside"
};
</script>

<style lang="scss" scoped>
#side-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 1rem;
}
.app-version {
  font-size: 0.7rem;
}
</style>
